import {
  FamilyChildProfile,
  FamilyParentProfile,
  Typography,
} from "@joonapp/web-shared"

import { UserInitial } from "./UserInitial"
import useRoutinesStore from "./useRoutinesStore"
import { useFamilyQuery } from "../../../networking/families/queries"

const FamilyToggle = () => {
  const { data: family } = useFamilyQuery()
  const { showParentCreatedRoutines } = useRoutinesStore()

  if (!showParentCreatedRoutines) return <></>

  return (
    <div className="flex flex-row w-full flex-wrap">
      <FamilyToggleItem profile={null} />
      {family?.profiles?.map((profile) => (
        <FamilyToggleItem key={profile.user.id} profile={profile} />
      ))}
    </div>
  )
}

export default FamilyToggle

const FamilyToggleItem = ({
  profile,
}: {
  profile: FamilyChildProfile | FamilyParentProfile | null
}) => {
  const { selectedUserId, setSelectedUserId } = useRoutinesStore()

  const isSelected = selectedUserId === (profile?.user.id ?? null)

  return (
    <button
      onClick={() => setSelectedUserId(profile?.user.id ?? null)}
      className="rounded-md"
    >
      <div
        className={`flex flex-row items-center justify-center gap-2 p-2 border rounded-md ${
          isSelected ? "border-borderPrimary shadow-low" : "border-transparent"
        } hover:border-neutral-200 hover:shadow-low`}
      >
        {profile && <UserInitial userProfile={profile} showTooltip={false} />}
        <div className="min-h-6 flex items-center">
          <Typography variant="bodySmall">
            {profile?.user.name || "All"}
          </Typography>
        </div>
      </div>
    </button>
  )
}
